export const getUniqueKey = () => {
  return `${Math.random()}-${new Date().getTime()}`;
};
